import React from 'react';
import { Button, message } from 'antd';
import { EnvironmentOutlined, HeartOutlined, ShopOutlined } from '@ant-design/icons';

import StarRating from '../../../components/shared/StarRating';

import {
  CoverArea,
  ProfilePicture,
  HeaderInfo,
  SellerName,
  SellerDescription,
  MetaRow,
  MetaItem,
  HeaderActions,
} from '../styles';

export default function SellerHeader({ seller }) {
  const handleFollow = () => {
    message.success('Siguiendo!');
  };

  return (
    <div>
      <CoverArea>
        {seller.coverImage && (
          <img src={seller.coverImage} alt={`Portada de ${seller.name}`} />
        )}
        <ProfilePicture>
          {seller.profileImage ? (
            <img src={seller.profileImage} alt={seller.name} />
          ) : (
            <ShopOutlined />
          )}
        </ProfilePicture>
      </CoverArea>

      <HeaderInfo>
        <SellerName>{seller.name}</SellerName>
        <SellerDescription>{seller.description}</SellerDescription>

        <MetaRow>
          <MetaItem>
            <EnvironmentOutlined />
            {seller.location}
          </MetaItem>
          <MetaItem>
            <StarRating value={seller.rating} count={seller.reviewCount} />
          </MetaItem>
        </MetaRow>

        <MetaRow>
          <MetaItem>
            <ShopOutlined />
            {seller.salesCount.toLocaleString('es-CR')} ventas
          </MetaItem>
          <MetaItem>
            <HeartOutlined />
            {seller.followers.toLocaleString('es-CR')} seguidores
          </MetaItem>
        </MetaRow>

        <HeaderActions>
          <Button type="primary" onClick={handleFollow}>
            Seguir
          </Button>
        </HeaderActions>
      </HeaderInfo>
    </div>
  );
}
